import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createBanner, fetchBanners, deleteBanner } from '../../../services/banner';

export const createBannerAsync = createAsyncThunk(
    'banner/create',
    async (formData, { rejectWithValue }) => {
        try {
            const response = await createBanner(formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to create banner');
        }
    }
);

export const fetchBannersAsync = createAsyncThunk(
    'banner/fetchList',
    async (siteCode, { rejectWithValue }) => {
        try {
            const response = await fetchBanners(siteCode);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch banners');
        }
    }
);

export const deleteBannerAsync = createAsyncThunk(
    'banner/delete',
    async ({ bannerId, siteCode }, { rejectWithValue }) => {
        try {
            const response = await deleteBanner(bannerId, siteCode);
            return { bannerId, ...response.data };
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to delete banner');
        }
    }
);

const bannerSlice = createSlice({
    name: 'banner',
    initialState: {
        banners: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBannersAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBannersAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = action.payload;
            })
            .addCase(fetchBannersAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createBannerAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createBannerAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.banners.push(action.payload);
            })
            .addCase(createBannerAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(deleteBannerAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteBannerAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.banners = state.banners.filter(banner => banner._id !== action.payload.bannerId);
            })
            .addCase(deleteBannerAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default bannerSlice.reducer;